import React, { useEffect } from 'react'
import { useParams, useSearchParams, Navigate } from 'react-router-dom'

const SupplierQuotationByParams = () => {
  const { id, supplierId } = useParams()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const cliente = searchParams.get('cliente')

  // Redirect to the existing SupplierQuotation component with the token
  if (token) {
    return <Navigate to={`/supplier/${token}`} replace />
  }

  // If no token, show error
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Link Inválido</h1>
        <p className="text-gray-600 mb-6">O link de cotação não contém um token válido.</p>
        <p className="text-sm text-gray-500">
          Cotação ID: {id}, Fornecedor ID: {supplierId}, Cliente: {cliente}
        </p>
      </div>
    </div>
  )
}

export default SupplierQuotationByParams
